import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Divider,
  Input,
  Typography,
  Table,
  Skeleton,
  Result,
  Tag
  //   Space
} from 'antd';
import {
  SearchOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { formatPhone } from '../../utils/customFunctions';
import CreateButton from '../../components/CreateButton';

const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'company',
    key: 'company',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/warehouses/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'ชื่อผู้ติดต่อ',
    dataIndex: 'fname',
    key: 'fname',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/warehouses/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'เบอร์โทร',
    dataIndex: 'phone',
    key: 'phone',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/warehouses/edit/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {formatPhone(text)}
      </Button>
  },
  // {
  //   title: 'อีเมล์',
  //   dataIndex: 'email',
  //   key: 'email',
  //   render: (text, record) =>
  //     <Button
  //       type='text'
  //       href={`/admin/vendors/edit/${record._id}`}
  //       style={{
  //         width: "100%",
  //         background: 'none',
  //         textAlign: 'left'
  //       }}>
  //       {text}
  //     </Button>
  // },
  {
    title: 'สถานะ',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (_, record) => record.is_active ? <Tag color="green">ดำเนินการ</Tag> : <Tag color="red">ปิดกิจการ</Tag>
  }
]


function List() {
  const [filterData, setFilterData] = useState(null);
  const { isLoading, isError, error, data } = useQuery({ queryKey: ['/api/warehouse/'] })

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.fname.includes(s) || f.company.includes(s) || f.phone.includes(s))
    setFilterData(target);
  }
  // console.log(data);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการคลังสินค้า
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <CreateButton linkTo='/admin/warehouses/create' />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="ค้นหา" prefix={<SearchOutlined />} onChange={onSearch} />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={filterData || data}
                scroll={{
                  x: 1200,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List